import 'url-search-params-polyfill';
import Vue from 'vue';
import VueMasonry from 'vue-masonry-css';
import vueSmoothScroll from 'vue-smoothscroll';

jQuery(document).ready(function() {
	if (!jQuery('.price-list').length) {
		return;
	}

	window.priceListCommonData = {
		areasAndTreatments: false,
		activeArea: false,
		selectableTreatments: [],
		selectedTreatment: false,
		selectingArea: true,
		selectingTreatment: false,
		priceSearchResults: [],
		priceSearchQuery: '',
		minimumQueryLength: 3,

		ui: {
			loading: {
				prices: true,
			},
			modalState: 0,
		},
	};

	window.priceListCommonMethods = {
		doPriceSearch() {
			this.priceSearchResults = [];
			var results = [];
			var resultsSlugs = []; // Keep track of the slugs of the treatments we display as search results so that we don't display the same treatment several times.

			let searchQuery = this.priceSearchQuery.toLowerCase();

			/* Only do the search if the query is longer than x characters */
			if (searchQuery.length >= this.minimumQueryLength) {
				for (let i in this.areasAndTreatments) {
					var area = this.areasAndTreatments[i];
					if (area.treatments && area.treatments.length) {
						for (var x in area.treatments) {
							var treatment = area.treatments[x];
							var treatmentName = treatment.name.toLowerCase();
							if (treatmentName.includes(searchQuery)) {
								if (!resultsSlugs.includes(treatment.slug)) {
									treatment.area = area;
									results.push(treatment);
									//resultsSlugs.push(treatment.slug);
								}
							}
						}
					}
				}
			} else {
				results = [];
			}
			this.priceSearchResults = results;
		},
		clearPriceSearchQuery() {
			this.priceSearchQuery = '';
			this.priceSearchResults = [];
		},
		handleSelectSearchResult(result) {
			this.setActiveArea(result.area);
			this.setActiveTreatment(result);
			this.$SmoothScroll(document.getElementById('price-areas-and-treatments-list-anchor'), 500);
		},
		setModalState: function(value) {
			/* Set the modal state. If the value is 0, the modal should not be shown and we'll remove the body class. If it is above 1, we'll add the body class */

			if (value > 0) {
				this.addBodyClass();
				this.ui.modalState = value;
			} else {
				this.removeBodyClass();
				this.ui.modalState = 0;
			}
		},

		/* Toggle a body element class when modal is opened/closed to prevent weird modal background scrolling on mobile Safari */
		toggleBodyClass: function() {
			var body = document.getElementsByTagName('BODY')[0];
			body.classList.toggle('mobile-menu-toggled');
		},

		removeBodyClass: function() {
			var body = document.getElementsByTagName('BODY')[0];
			body.classList.remove('mobile-menu-toggled');
		},

		addBodyClass: function() {
			var body = document.getElementsByTagName('BODY')[0];
			body.classList.add('mobile-menu-toggled');
		},

		setupPriceListByPriceId(priceSlug) {
			for (var i in this.areasAndTreatments) {
				var area = this.areasAndTreatments[i];
				for (var x in this.areasAndTreatments[i].treatments) {
					var treatment = this.areasAndTreatments[i].treatments[x];
					if (treatment.slug == priceSlug) {
						this.setActiveArea(area);
						this.setActiveTreatment(treatment);
						return;
					}
				}
			}
		},

		setupPriceList() {
			if (window.profetPreload && window.profetPreload.pricedata) {
				this.ui.loading.prices = false;
				this.areasAndTreatments = window.profetPreload.pricedata;
				/* Order treatment areas */
				this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) => o.order);
				/* Order treatment types */
				for (var i in this.areasAndTreatments) {
					this.areasAndTreatments[i].treatments = _.sortBy(this.areasAndTreatments[i].treatments, (o) => parseInt(o.order, 10));
				}
				this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) => parseInt(o.order, 10));

				/* Check if there's a query parameter set for the price id */
				var uri = window.location.search.substring(1);
				var params = new URLSearchParams(uri);
				if (params.get('behandling')) {
					/* Call method to set up the price list so that the 'correct' price gets displayed by default */
					this.setupPriceListByPriceId(params.get('behandling'));
				}
			} else {
				axios.get('/wp-json/nk/getTreatmentPrices/').then((response) => {
					this.ui.loading.prices = false;
					this.areasAndTreatments = response.data.data;
					/* Order treatment areas */
					this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) => o.order);
					/* Order treatment types */
					for (var i in this.areasAndTreatments) {
						this.areasAndTreatments[i].treatments = _.sortBy(this.areasAndTreatments[i].treatments, (o) => parseInt(o.order, 10));
					}
					this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) => parseInt(o.order, 10));
				});
			}
		},

		setActiveArea(area) {
			this.activeArea = area;
			this.selectableTreatments = [];
			this.selectingArea = false;
			this.selectingTreatment = true;
			area.expanded = true;

			for (var treatment in this.activeArea.treatments) {
				var singleTreatment = this.activeArea.treatments[treatment];
				this.selectableTreatments.push(singleTreatment);
			}

			/* Order all treatments */
			this.selectableTreatments = _.sortBy(this.selectableTreatments, (o) => parseInt(o.order, 10));
		},

		setActiveTreatment(treatment) {
			this.selectingTreatment = false;
			this.selectedTreatment = treatment;
			this.activeArea.expanded = true;
			this.updateURL('?behandling=' + treatment.slug);
		},

		resetFilters() {
			this.updateURL('');
			this.activeArea = false;
			this.selectableTreatments = [];
			this.selectingArea = true;
			this.selectingTreatment = false;
			this.selectedTreatment = false;

			for (var i in this.areasAndTreatments) {
				this.areasAndTreatments[i].expanded = false;
			}
		},

		closeModal() {
			this.ui.modalState = 0;
		},

		generateBookingLink(treatment) {
			if (treatment.activity_id == null) {
				return '/boka-tid/';
			} else {
				return '/boka-tid/' + '?activity_id=' + treatment.activity_id;
			}
		},

		/* Insert query parameter in url */
		/* https://eureka.ykyuen.info/2015/04/08/javascript-add-query-parameter-to-current-url-without-reload/ */
		updateURL(queryStringToAdd) {
			if (history.pushState) {
				var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + queryStringToAdd;
				window.history.pushState({ path: newurl }, '', newurl);
			}
		},
	};

	Vue.use(VueMasonry);
	Vue.use(vueSmoothScroll);

	new Vue({
		el: '.price-list',

		data: window.priceListCommonData,

		methods: window.priceListCommonMethods,

		created() {
			this.setupPriceList();
		},

		computed: {},
	});
});
